//import Libraries
import React from 'react';
import PropTypes from 'prop-types'

//import Styles
import './MyInfo.css'


const mypageTextFormLine = ({type, editing, label, name, value, handleOnChange, placeholder, errorText}) => {

    return (
        <div className="Element">
            <label style={{fontWeight: 900}}>{label} | </label>
            <div className="Content">
            {
                editing ? (
                    <input name={name} type={type} value={value} onChange={handleOnChange} placeholder={placeholder}/>
                ) : (
                    <div> {value} </div>
                )
            }
            </div>
            <div className="Error">
                {errorText}
            </div>
        </div>
    );
}

export default mypageTextFormLine;

mypageTextFormLine.propTypes ={
    placeholder : PropTypes.string,
    type : PropTypes.string
} 

mypageTextFormLine.defaultProps = {
    placeholder : '',
    type : 'text',
    errorText : ''
}


// WEBPACK FOOTER //
// ./src/pages/MyPage/MyPageTextFormLine.js